import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useMemo } from "react";
import { useApprovalRules } from "../../../hooks/approvals/useApprovalRules";
import { useUserOrganizations } from "../../../hooks/use-user-organizations";
import { useContextTypeSettingsOrganization } from "../dashboard-layout";
import ApprovalRulesTable from "./approval-rules-table";
import { ApprovalRule } from "../../../API";

const ApprovalRules = () => {
  const { selectedOrganization } = useContextTypeSettingsOrganization();
  const { data: rules = [] } = useApprovalRules(selectedOrganization?.id);
  const { userOrganizations } = useUserOrganizations({ selectedOrganization });

  // D-09: hard gate on rule creation. Real "has any approver configured" check.
  const hasApprovers =
    Boolean(selectedOrganization?.defaultEmployeeApproverUserId) ||
    (userOrganizations ?? []).some(
      (uo) => !uo.deletedAt && Boolean(uo.approverUserId)
    );

  const activeRules = useMemo(
    () => rules.filter((r: ApprovalRule) => r.isActive),
    [rules]
  );

  const inactiveRules = useMemo(
    () => rules.filter((r: ApprovalRule) => !r.isActive),
    [rules]
  );

  return (
    <VStack width="full" alignItems="start" spacing="20px">
      {!hasApprovers && (
        <Text fontSize={14} color="orange.600" fontWeight="medium">
          Bitte legen Sie zuerst einen Freigeber fest – entweder einen
          Standardfreigeber im Tab &quot;Allgemein&quot; oder einen individuellen
          Freigeber pro Mitarbeiter im Tab &quot;Teammitglieder&quot;.
        </Text>
      )}

      <Tabs variant="soft-rounded" size="sm" width="full">
        <TabList>
          <Tab>Aktiv ({activeRules.length})</Tab>
          <Tab>Inaktiv ({inactiveRules.length})</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <ApprovalRulesTable
              rules={activeRules}
              isActiveTab
              hasApprovers={hasApprovers}
            />
          </TabPanel>
          <TabPanel px={0}>
            <ApprovalRulesTable
              rules={inactiveRules}
              isActiveTab={false}
              hasApprovers={hasApprovers}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
};

export default ApprovalRules;
